<template>
    <div>
        <div v-if="!user">Loading...</div>
        <div v-else>
            <div class="col-6 mb-10">
                <button class="btn btn-sm btn-danger" @click.prevent="transactionModal">
                    Create Transaction
                </button>
            </div class="block-content">
            <div class="col-sm-12 table-responsive">
                <table class="table table-striped table-vcenter">
                    <thead>
                        <tr role="row">
                            <th class="text-center" tabindex="0">
                                #
                            </th>

                            <th class="text-capitalize">Transaction ID</th>
                            <th style="width: 100px;" class="text-capitalize"> Date</th>

                            <th class="text-capitalize">
                                Amount
                            </th>
                            <th class="text-capitalize">
                                Status
                            </th>

                            <th class="text-capitalize">
                                Debit/Credit
                            </th>
                            <th class="text-capitalize">
                                Description
                            </th>

                            <th class="text-center text-capitalize">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr role="row" class="odd" v-for="(transaction,
                            index) in user.logs.data" :key="index">
                            <td class="text-center sorting_1">
                                {{ index + 1 }}
                            </td>
                            <td>
                                {{ transaction.reference }}
                            </td>
                            <td>
                                {{ transaction.created_at }}
                            </td>
                            <td>
                                {{ transaction.currency.symbol
                                }}{{
                                    transaction.amount


                                }}
                            </td>
                            <td>
                                <span class="text-warning" v-if="transaction.status == 0">Pending</span>
                                <span class="text-success" v-else>Success</span>
                            </td>


                            <td>
                                <span class="text-danger" v-if="transaction.is_credit == 0">DEBIT</span>
                                <span class="text-success" v-else>CREDIT</span>
                            </td>
                            <td class="text-uppercase"> {{ transaction.details }}</td>

                            <td>
                                <div class="btn-group">
                                    <button style="margin-right: 4px" type="button" class="btn btn-sm"
                                        :class="{ 'btn-danger': transaction.status == 1, 'btn-success': transaction.status == 0 }"
                                        data-toggle="tooltip" title="Delete" @click.prevent="
                                            updateStatus(transaction.id, transaction.status)
                                            ">
                                        <span v-if="transaction.status == 0">Approve</span>
                                        <span v-if="transaction.status == 1">Unapprove</span>
                                    </button>

                                    <button type="button" class="btn btn-sm btn-danger" data-toggle="tooltip"
                                        title="Delete" @click.prevent="
                                            deleteTransaction(transaction.id)
                                            ">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination :data="user.logs" @pagination-change-page="getTransactions">
                    <span slot="prev-nav">&lt; Previous</span>
                    <span slot="next-nav">Next &gt;</span>
                </pagination>
            </div>


            <!-- transactions modal  -->
            <div class="modal fade" id="modal-transactions" tabindex="-1" role="dialog" aria-labelledby="modal-fadein"
                style="display: none;" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="card-title">Create Transaction</h3>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- Beginning of the form -->
                        <form @submit.prevent="createTransaction">
                            <div class="modal-body">
                                <div class="card">
                                    <div class="card-body">

                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="name">Select Account</label>
                                                <select type="text" class="form-control" v-model="from" required>
                                                    <option value selected disabled>--- Select Account
                                                        ---</option>
                                                    <option v-for="account in user.accounts" :key="account.id"
                                                        v-if="account.isActive == 1" :value="account.id"> {{
                                                        account.currency.symbol }}{{ parseFloat(
                                                            account.balance
                                                        )
                                                            .toFixed(2)
                                                            .replace(
                                                                /(\d)(?=(\d{3})+(?!\d))/g,
                                                                "$1,"
                                                            ) }} - {{ account.number }} </option>
                                                </select>
                                            </div>

                                        </div>

                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="trans_option">Fund transfer option</label>
                                                <select name="trans_option" id="trans_option" class="form-control"
                                                    required v-model="trans_option">
                                                    <option disabled="" selected="">Select Option</option>
                                                    <option value="wire">Wire
                                                        Transfer</option>
                                                    <option value="other">other
                                                        Banks</option>
                                                    <option value="local">Local Transfer</option>
                                                </select>
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="trans_option">Transfer Option</label>
                                                <select name="trans_option" id="trans_option" class="form-control"
                                                    required v-model="is_credit">
                                                    <option value="1">Credit</option>
                                                    <option value="0">Debit</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row" v-if="is_credit == 1">
                                            <div class="col-lg-6">
                                                <label for="account">Sender Account
                                                    Number</label>
                                                <input id="account" type="text" class="form-control"
                                                    autocomplete="phone" v-model="sender_account" />

                                            </div>
                                            <div class="col-lg-6">
                                                <label for="fullname">Sender Fullname</label>
                                                <input id="fullname" name="lastname" type="text" class="form-control"
                                                    v-model="sender_name" />


                                            </div>
                                        </div>
                                        <div class="form-group row" v-if="is_credit == 0">
                                            <div class="col-lg-6">
                                                <label for="receiver_name">Receiver's Fullname</label>
                                                <input v-if="is_credit == 0" id="receiver_name" name="receiver_name"
                                                    type="text" class="form-control" v-model="receiver_name" />

                                            </div>
                                            <div class="col-lg-6">
                                                <label for="receiver_account">Receiver's Account
                                                    Number</label>

                                                <input id="receiver_account" type="text" class="form-control"
                                                    autocomplete="phone" v-model="receiver_account" />
                                            </div>
                                        </div>
                                        <div class="form-group row">

                                            <div class="col-lg-6" v-if="trans_option !== 'local'">
                                                <label for="bank_name">Bank Name</label>
                                                <input id="bank_name" type="text" class="form-control"
                                                    v-model="bank_name" />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="amount">Amount</label>
                                                <input id="amount" type="text" class="form-control"
                                                    autocomplete="amount" v-model="amount" />
                                            </div>
                                        </div>

                                        <div class="form-group row">


                                            <div class="col-lg-6">
                                                <label for="date">Transaction Date</label>
                                                <input v-model="date" type="datetime-local"
                                                    class="js-datepicker form-control" id="date"
                                                    name="example-datepicker3" placeholder="dd-mm-yyyy" />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="description">Transfer Description</label>
                                                <textarea v-model="description" name="desc" class="form-control"
                                                    placeholder="">
                                                </textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div v-if="processing" class="col-6 col-md-3">
                                                <i class="fa fa-2x fa-cog fa-spin text-primary"></i>
                                            </div>
                                            <div class="col-md-9" v-else>
                                                <button type="submit" class="btn btn-lg btn-outline-info mb-2">
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- transactions modal ends  -->

            <!-- transaction edit modal  -->
            <div class="modal fade" id="modal-edit" tabindex="-1" role="dialog" aria-labelledby="modal-fadein"
                style="display: none;" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="card-title">Update Transaction</h3>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- Beginning of the form -->
                        <form @submit.prevent="updateTransaction">
                            <div class="modal-body">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="account">Sender Account
                                                    Number</label>
                                                <input id="account" type="text" class="form-control"
                                                    autocomplete="phone" v-model="current_txn.sender_account" />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="fullname">Sender Fullname</label>
                                                <input id="fullname" name="lastname" type="text" class="form-control"
                                                    v-model="current_txn.sender_name
                                                        " />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="receiver_name">Receiver's Fullname</label>
                                                <input id="receiver_name" name="receiver_name" type="text"
                                                    class="form-control" v-model="current_txn.receiver_name" />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="receiver_account">Receiver's Account
                                                    Number</label>
                                                <input id="receiver_account" type="text" class="form-control"
                                                    autocomplete="phone" v-model="current_txn.receiver_account" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="trans_option">Fund transfer type</label>
                                                <select name="trans_option" id="trans_option" class="form-control"
                                                    required v-model="current_txn.is_credit">
                                                    <option value="1">Credit</option>
                                                    <option value="0">Debit</option>
                                                </select>
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="bank_name">Bank Name</label>
                                                <input id="bank_name" type="text" class="form-control"
                                                    v-model="current_txn.bank_name" />
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="trans_option">Fund transfer option</label>
                                                <select name="trans_option" id="trans_option" class="form-control"
                                                    required v-model="current_txn.trans_option">
                                                    <option disabled="" selected="">Select Option</option>
                                                    <option value="international">International
                                                        Transfer</option>
                                                    <option value="domestic">Domestic
                                                        Transfer</option>
                                                    <option value="local">Local Transfer</option>
                                                </select>
                                            </div>

                                            <div class="col-lg-6">
                                                <label for="date">Transaction Date</label>

                                                <input v-model="current_txn.date2" type="date"
                                                    class="js-datepicker form-control" id="date"
                                                    name="example-datepicker3" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-12">
                                                <label for="description">Transfer Description</label>
                                                <textarea v-model="current_txn.description" name="desc"
                                                    class="form-control" placeholder="">
                                                </textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div v-if="processing" class="col-6 col-md-3">
                                                <i class="fa fa-2x fa-cog fa-spin text-primary"></i>
                                            </div>
                                            <div class="col-md-9" v-else>
                                                <button type="submit" class="btn btn-lg btn-danger mb-2">
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- transactions modal ends  -->
        </div>
    </div>
</template>
<script>
import { RepositoryFactory } from "../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");
export default {
    props: {
        user: Object,
    },
    data() {
        return {
            date: "",
            amount: 0,
            description: "",
            trans_option: "international",
            receiver_name: "",
            sender_name: "",
            currency: this.user.currency,
            receiver_account: "",
            sender_account: "",
            receiver_account: "",
            is_credit: 1,
            bank_name: "",
            account: "balance",
            type: 1,
            processing: false,
            current_txn: {},
            prevAmount: 0,
            logs: [],
            logData: {},
            from: ''
        };
    },
    methods: {
        editModal(txn) {
            this.current_txn = txn;
            this.prevAmount = txn.amount;
            $('#modal-edit').modal('show')
        },
        async getTransactions(page = 1) {
            this.$emit("refresh", page);
        },
        async updateStatus(id, status) {
            swal.fire({
                title: "Are you sure?",
                text: status == 1 ? "You are about to unapprove this" : "You are about to approve this",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: status == 1 ? 'UnApprove it' : "Yes, Approve"
            }).then(async result => {
                // Send request to the server
                if (result.value) {
                    try {
                        await UsersRepository.adminUpdateTransactionStatus(id);
                        this.refresh();
                    } catch (error) {
                        swal(
                            "Failed!",
                            "There was something wrong.",
                            "warning"
                        );
                    }
                }
            });

        },
        async updateTransaction() {
            try {
                this.processing = true;
                let data = this.current_txn;
                data.prevAmount = this.prevAmount;
                console.log(data)
                await UsersRepository.adminUpdateTransaction(this.current_txn.id, data);
                $('#modal-edit').modal('hide')
                this.processing = false;
                this.refresh();
                window.location.reload();
                return toast.fire({
                    type: "success",
                    title: "Transaction updated successfully"
                });
            } catch (error) {
                this.processing = false;
                return toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        deleteTransaction(id) {
            swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then(async result => {
                // Send request to the server
                if (result.value) {
                    try {
                        await UsersRepository.adminDeleteTransaction(id);
                        swal.fire(
                            "Deleted!",
                            'Transaction deleted successfully',
                            "success"
                        );
                        this.refresh();
                    } catch (error) {
                        swal(
                            "Failed!",
                            "There was something wrong.",
                            "warning"
                        );
                    }
                }
            });

        },
        transactionModal() {
            $("#modal-transactions").modal("show");
        },
        refresh() {
            this.$emit("refresh");
        },
        async createTransaction() {
            try {

                this.processing = true;

                // if is_credit == 1
                let aName = this.sender_name;
                let aNumber = this.sender_account;
                if (this.is_credit == 0) {
                    aName = this.receiver_name;
                    aNumber = this.receiver_account;
                }

                var data = {
                    is_credit: this.is_credit,
                    user_id: this.user.id,
                    account_name: aName,
                    account_number: aNumber,
                    transfer_type: this.trans_option,
                    date: this.date,
                    description: this.description,
                    bank_name: this.bank_name,
                    amount: this.amount,
                    account: this.from
                };

                await UsersRepository.adminCreateTransaction(data);
                this.refresh();
                $("#modal-transactions").modal("hide");
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Account status updated"
                });
            } catch (error) {
                console.log(error);
                this.processing = false;
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },

    }
};
</script>
